<template>
  <div>
    <van-nav-bar
      to="TeaList"
      title="添加教师"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
    />
    <van-form @submit="onSubmit">
      <van-field
        clearable
        v-model="username"
        name="tecname"
        label="姓名"
        placeholder="姓名"
        :rules="[{ required: true, message: '请填写姓名' }]"
      />
      <van-field
        clearable
        v-model="password"
        type="number"
        name="tecnum"
        label="工号"
        placeholder="工号"
        :rules="[{ required: true, message: '请填写工号' }]"
      />

      <van-field
        readonly
        clickable
        name="gender"
        :value="value"
        label="性别"
        placeholder="点击选择性别"
        @click="showPicker = true"
      />
      <van-popup v-model="showPicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="columns"
          @confirm="onConfirm"
          @cancel="showPicker = false"
          :default-index="0"
        />
      </van-popup>
      <div style="margin: 16px;">
        <van-button round block type="info" native-type="submit">
          添加教师
        </van-button>
      </div>
    </van-form>

    <van-divider/>

    <div style="text-align:center;">
      <!--      accept=".xls,.xlsx"-->
      <van-uploader accept=".xls,.xlsx" v-model="fileList" :max-count="1" :before-read="before_read"
                    :after-read="after_read" :before-delete="delete_file">
        <van-button round block icon="plus" type="primary">文件导入</van-button>
      </van-uploader>
    </div>

    <van-cell-group>
      <van-cell v-for="(item,index) in FailTeacherList" :title="item.tName+' '+item.gender+' '+item.tNum" value="失败"
                :key="index"/>
    </van-cell-group>
  </div>
</template>

<script>
import Vue from 'vue';
import {NavBar, Form, Field, Button, Picker, Popup, Dialog, Uploader, Cell, CellGroup, Divider, Toast} from 'vant';
import {AddTeacher} from "network/teacher"

import {upLoadTeachers} from "../../../network/upLoader";

Vue.use(Form);
Vue.use(NavBar);
Vue.use(Field);
Vue.use(Button);
Vue.use(Picker);
Vue.use(Popup);
Vue.use(Dialog);
Vue.use(Uploader);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Divider);
Vue.use(Toast);
export default {
  name: "Addteacher",
  data() {
    return {
      username: '',
      password: '',
      value: '',
      columns: ['男', '女'],
      showPicker: false,
      fileList: [],
      FailTeacherList: []
    };
  },
  methods: {
    before_read(file) {
      // console.log(file);
      let fileTypes = file.name.split('.');
      let fileType = fileTypes[fileTypes.length - 1];
      if (fileType !== 'xlsx' && fileType !== 'xls') {
        Dialog.alert({
          message: '请上传 xlsx或xls 格式文件',
        });
        return false;
      } else if (file.size > 5039264) {
        Dialog.alert({
          message: '文件过大,请保持在5M以内',
        });
        return false;
      }
      return true;
    },
    after_read(file) {
      file.status = 'uploading';
      file.message = '上传中...';
      let data = new FormData();
      data.append("file", file.file);
      upLoadTeachers(data).then(res => {
        if (res.status) {
          file.status = 'done';
          file.message = '导入成功';
          this.FailTeacherList = res.failteachers;
          Dialog.alert({
            title: '导入信息',
            message: '成功:' + res.success + ',失败:' + res.fail,
          });
        } else {
          file.status = 'failed';
          file.message = '导入失败';
        }
      })

    },
    delete_file() {
      this.FailTeacherList = [];
      return true;
    },
    Dialoginfo(title, message) {
      Dialog.alert({
        title,
        message
      }).then(() => {
        // on close
      });
    },
    onClickLeft() {
      // this.$router.back(-1);
      this.$router.replace("TeaList");
    },
    onSubmit(values) {
      // console.log('submit', values);
      if (values.gender === "") {
        this.Dialoginfo('提示', '性别不能为空');
      } else {
        AddTeacher(values.tecname, values.tecnum, values.gender).then(res => {
          if (res) {
            this.Dialoginfo('提示', '添加成功');
          } else {
            this.Dialoginfo('提示', '添加失败');
          }
        }).catch(res => {
          this.Dialoginfo('提示', '添加失败');
        })
      }
    },
    onConfirm(value) {
      this.value = value;
      this.showPicker = false;
    },
  }
}
</script>

<style scoped>

</style>
